import { ROUTE_PATH } from "utils/constants/routePath";
import { Icons } from "components";
import HomeContainer from "containers/HomeContainer";
import ActivitiesContainer from "containers/ActivitiesSystem/ActivitiesContainer";
import ActivitiesDetailContainer from "containers/ActivitiesSystem/ActivitiesDetailContainer";
import ActivitySeatBookingContainer from "containers/ActivitiesSystem/ActivitySeatBookingContainer";
import ActivityCertificateContainer from "containers/ActivitiesSystem/ActivityCertificateContainer";
import OnlineFormCertificateContainer from "containers/ActivityFormSystem/OnlineFormCertificateContainer";
import ActivitiesFormDetailContainer from "containers/ActivitiesSystem/ActivitiesFormDetailContainer";
import ActivityFormQuizContainer from "containers/ActivitiesSystem/ActivityFormQuizContainer";
import ActivityFormRequestEditContainer from "containers/ActivitiesSystem/ActivityFormRequestEditContainer";
import ActivityFormThankContainer from "containers/ActivitiesSystem/ActivityFormThankContainer";
import ActivityFormCusPreviewContainer from "containers/ActivitiesSystem/ActivityFormCusPreviewContainer";
import ProductWarranteeDetailContainer from "containers/ProductWarranteeSystem/ProductWarranteeDetailContainer";
import ProductWarranteeSuccessContainer from "containers/ProductWarranteeSystem/ProductWarranteeSuccessContainer";
import SpecialPointsContainer from "containers/SpecialPointsSystem/SpecialPointsContainer";
import FavouriteFeature from "containers/SpecialPointsSystem/SpecialPointsContainer/Features/FavouriteFeature/FavouriteContainer";
import QuickTestContainer from "containers/SpecialPointsSystem/SpecialPointsContainer/Features/FavouriteFeature/QuickTestContainer";
import QuickTestSuccessContainer from "containers/SpecialPointsSystem/SpecialPointsContainer/Features/FavouriteFeature/QuickTestSuccessContainer";
import GameFeature from "containers/SpecialPointsSystem/SpecialPointsContainer/Features/GameFeature/GameContainer";
import PointRedeemContainer from "containers/PointRedeemSystem/PointRedeemContainer";
import EcouponContainer from "containers/PointRedeemSystem/PointRedeemContainer/Tabs/EcouponContainer";
import GiftContainer from "containers/PointRedeemSystem/PointRedeemContainer/Tabs/GiftContainer";
import VoucherContainer from "containers/PointRedeemSystem/PointRedeemContainer/Tabs/VoucherContainer";
import PointRedeemDetailContainer from "containers/PointRedeemSystem/PointRedeemContainer/Steps/PointRedeemDetailContainer";
import PointRedeemQRCodeContainer from "containers/PointRedeemSystem/PointRedeemContainer/Steps/PointRedeemQRCodeContainer";
import PointRedeemShippingContainer from "containers/PointRedeemSystem/PointRedeemContainer/Steps/PointRedeemShippingContainer";
import HistoryContainer from "containers/HistorySystem/HistoryContainer";
import ActivityHistoryContainer from "containers/HistorySystem/HistoryContainer/Tabs/ActivityHistoryContainer";
import ProductWarrantyHistoryContainer from "containers/HistorySystem/HistoryContainer/Tabs/ProductWarrantyHistoryContainer";
import NewContainer from "containers/NewSystem/NewContainer";
import NewDetailContainer from "containers/NewSystem/NewDetailContainer";
import ProfileContainer from "containers/ProfileSystem/ProfileContainer";
import BookingContainer from "containers/BookingSystem/BookingContainer";
import BookingDetailContainer from "containers/BookingSystem/BookingDetailContainer";
import PrivilegeContainer from "containers/PrivilegeSystem/PrivilegeContainer";
import PrivilegeDetailContainer from "containers/PrivilegeSystem/PrivilegeDetailContainer";
import PianoTuningDetailContainer from "containers/HistorySystem/HistoryContainer/Tabs/ProductWarrantyHistoryContainer/PianoTuningDetailContainer";
import ProfileInstrumentDetailContainer from "containers/ProfileSystem/ProfileInstrumentDetailContainer";
import RewardDetailContainer from "containers/RewardSystem/RewardDetailContainer";
import MusicHallAndPracticeDetailContainer from "containers/RoomSystem/MusicHallAndPracticeDetailContainer";
import MusicHallAndPracticeInfoContainer from "containers/RoomSystem/MusicHallAndPracticeInfoContainer";
import MusicPracticeRoomContainer from "containers/RoomSystem/MusicPracticeRoomContainer";
import Step1ScheduleReserveContainer from "containers/RoomSystem/Step1ScheduleReserveContainer";
import Step2ScheduleReserveContainer from "containers/RoomSystem/Step2ScheduleReserveContainer";
import Step3ScheduleReserveContainer from "containers/RoomSystem/Step3ScheduleReserveContainer";
import Step4ScheduleReserveContainer from "containers/RoomSystem/Step4ScheduleReserveContainer";
import Step5ScheduleReserveContainer from "containers/RoomSystem/Step5ScheduleReserveContainer";
import Step6ScheduleReserveContainer from "containers/RoomSystem/Step6ScheduleReserveContainer";
import Step7ScheduleReserveContainer from "containers/RoomSystem/Step7ScheduleReserveContainer";
import Step8ScheduleReserveContainer from "containers/RoomSystem/Step8ScheduleReserveContainer";
import Step9ScheduleReserveContainer from "containers/RoomSystem/Step9ScheduleReserveContainer";
import StepConditionScheduleReserveContainer from "containers/RoomSystem/StepConditionScheduleReserveContainer";
import MusicPracticeRoomDetailContainer from "containers/RoomSystem/MusicPracticeRoomDetailContainer";
import MusicPracticeRoomStep1Container from "containers/RoomSystem/MusicPracticeRoomStep1Container";
import MusicPracticeRoomStep2Container from "containers/RoomSystem/MusicPracticeRoomStep2Container";
import MusicPracticeRoomContactContainer from "containers/RoomSystem/MusicPracticeRoomContactContainer";
import MusicHallAndPracticeThankContainer from "containers/RoomSystem/MusicHallAndPracticeThankContainer";
import ActivityFormAdminPreviewContainer from "containers/ActivitiesSystem/ActivityFormAdminPreviewContainer";
import ActivityQRRegisterContainer from "containers/ActivitiesSystem/ActivityQRRegisterContainer";

const systemRoutes = [
  {
    key: "home",
    name: "Home",
    path: ROUTE_PATH.HOME,
    element: <HomeContainer />,
  },
  {
    key: "activities",
    name: "Activities",
    path: ROUTE_PATH.ACTIVITIES,
    element: <ActivitiesContainer />,
  },
  {
    key: "activities",
    name: "Activities",
    path: ROUTE_PATH.ACTIVITY_QR_REGISTER,
    element: <ActivityQRRegisterContainer />,
  },
  {
    key: "activities",
    name: "Activities",
    path: ROUTE_PATH.ACTIVITY_CERTIFICATE,
    element: <ActivityCertificateContainer />,
  },
  {
    key: "activities_form",
    name: "Activities Form",
    path: ROUTE_PATH.ONLINE_FORM_CERTIFICATE,
    element: <OnlineFormCertificateContainer />,
  },
  {
    key: "activities",
    name: "Activities",
    path: ROUTE_PATH.ACTIVITIES_DETAIL,
    element: <ActivitiesDetailContainer />,
  },
  {
    key: "activities",
    name: "Activities",
    path: ROUTE_PATH.ACTIVITIES_SEAT_BOOKING,
    element: <ActivitySeatBookingContainer />,
  },
  {
    key: "activities_form",
    name: "Activities Form",
    path: ROUTE_PATH.ACTIVITY_FORM_DETAIL,
    element: <ActivitiesFormDetailContainer />,
  },
  {
    key: "activities_form",
    name: "Activities Form",
    path: ROUTE_PATH.ACTIVITY_FORM_QUIZ,
    element: <ActivityFormQuizContainer />,
  },
  {
    key: "activities_form",
    name: "Activities Form",
    path: ROUTE_PATH.ACTIVITY_FORM_QUIZ_REQUEST_EDIT,
    element: <ActivityFormRequestEditContainer />,
  },
  {
    key: "activities_form",
    name: "Activities Form",
    path: ROUTE_PATH.ACTIVITY_FORM_QUIZ_THANK_YOU,
    element: <ActivityFormThankContainer />,
  },
  {
    key: "activities_form",
    name: "Activities Form",
    path: ROUTE_PATH.ACTIVITY_FORM_PREVIEW,
    element: <ActivityFormAdminPreviewContainer />,
  },

  
  {
    key: "activities_form",
    name: "Activities Form",
    path: ROUTE_PATH.ACTIVITY_FORM_QUIZ_PREVIEW,
    element: <ActivityFormCusPreviewContainer />,
  },
  {
    key: "product_warrantee",
    name: "Product Warranty",
    path: ROUTE_PATH.PRODUCT_WARRANTEE_DETAIL,
    element: <ProductWarranteeDetailContainer />,
  },
  {
    key: "product_warrantee",
    name: "Product Warranty",
    path: ROUTE_PATH.PRODUCT_WARRANTEE_SUCCESS_DETAIL,
    element: <ProductWarranteeSuccessContainer />,
  },
  {
    key: "special_points",
    name: "Special Points",
    path: ROUTE_PATH.SPECIAL_POINTS,
    element: (
      <SpecialPointsContainer
        data={[
          {
            key: "favourite",
            name: "Survey",
            name_th: "",
            icon: <Icons.Survey color="#fff"/>,
            path: ROUTE_PATH.SPECIAL_POINTS_FAV,
            element: <FavouriteFeature />,
          },
          {
            key: "game",
            name: "Game lucky draw",
            name_th: "",
            icon: <Icons.GameLuckyDraw color="#fff"/>,
            path: ROUTE_PATH.SPECIAL_POINTS_GAME,
            element: <GameFeature />,
          },
        ]}
      />
    ),
  },
  {
    key: "special",
    name: "Special Points",
    path: ROUTE_PATH.SPECIAL_POINTS_FAV_QUICK_DETAIL,
    element: <QuickTestContainer />,
  },
  {
    key: "special",
    name: "Special Points",
    path: ROUTE_PATH.SPECIAL_POINTS_FAV_QUICK_SUCCESS_DETAIL,
    element: <QuickTestSuccessContainer />,
  },
  {
    key: "favourite",
    name: "Favourite",
    path: ROUTE_PATH.SPECIAL_POINTS_FAV,
    element: <FavouriteFeature />,
  },
  {
    key: "game",
    name: "Game",
    path: ROUTE_PATH.SPECIAL_POINTS_GAME,
    element: <GameFeature />,
  },
  {
    key: "privilege",
    name: "Privilege",
    path: ROUTE_PATH.PRIVILEGE,
    element: <PrivilegeContainer />,
  },
  {
    key: "privilege",
    name: "Privilege Detail",
    path: ROUTE_PATH.PRIVILEGE_DETAIL,
    element: <PrivilegeDetailContainer />,
  },
  {
    key: "point_redeem",
    name: "Point Redeem",
    path: ROUTE_PATH.POINT_REDEEM,
    element: (
      <PointRedeemContainer
        data={[
          {
            key: "e_coupon",
            name: "E-Coupon",
            path: ROUTE_PATH.POINT_REDEEM_E_COUPON,
            icon: <Icons.RedeemECoupon />,
            iconAct: <Icons.RedeemECoupon color="#fff" />,
            element: <EcouponContainer />,
          },
          {
            key: "voucher",
            name: "Voucher",
            path: ROUTE_PATH.POINT_REDEEM_VOUCHER,
            icon: <Icons.RedeemVoucher />,
            iconAct: <Icons.RedeemVoucher color="#fff" />,
            element: <VoucherContainer />,
          },
          {
            key: "gift",
            name: "Gift",
            path: ROUTE_PATH.POINT_REDEEM_GIFT,
            icon: <Icons.RedeemGift />,
            iconAct: <Icons.RedeemGift color="#fff" />,
            element: <GiftContainer />,
          },
        ]}
      />
    ),
    children: [
      {
        key: "e_coupon",
        name: "E-Coupon",
        path: ROUTE_PATH.POINT_REDEEM_E_COUPON,
        element: <EcouponContainer />,
      },
      {
        key: "voucher",
        name: "Voucher",
        path: ROUTE_PATH.POINT_REDEEM_VOUCHER,
        element: <VoucherContainer />,
      },
      {
        key: "gift",
        name: "Gift",
        path: ROUTE_PATH.POINT_REDEEM_GIFT,
        element: <GiftContainer />,
      },
      {
        key: "e_coupon",
        name: "E-Coupon",
        path: ROUTE_PATH.POINT_REDEEM_DETAIL,
        element: <PointRedeemDetailContainer />,
      },
      {
        key: "e_coupon",
        name: "E-Coupon",
        path: ROUTE_PATH.POINT_REDEEM_QRCODE_DETAIL,
        element: <PointRedeemQRCodeContainer />,
      },
      {
        key: "e_coupon",
        name: "E-Coupon",
        path: ROUTE_PATH.POINT_REDEEM_SHIPPING_DETAIL,
        element: <PointRedeemShippingContainer />,
      },
    ],
  },
  {
    key: "history",
    name: "History",
    path: ROUTE_PATH.HISTORY,
    element: <HistoryContainer />,
  },
  {
    key: "history",
    name: "History",
    path: ROUTE_PATH.HISTORY_ACTIVITY,
    element: <ActivityHistoryContainer />,
  },
  {
    key: "history",
    name: "History",
    path: ROUTE_PATH.HISTORY_PRODUCT_WARRANTY,
    element: <ProductWarrantyHistoryContainer />,
  },
  {
    key: "history",
    name: "History",
    path: ROUTE_PATH.HISTORY_PIANO_TUNING_DETAIL,
    element: <PianoTuningDetailContainer />,
  },
  {
    key: "new",
    name: "News",
    path: ROUTE_PATH.NEW,
    element: <NewContainer />,
  },
  {
    key: "new",
    name: "News",
    path: ROUTE_PATH.NEW_DETAIL,
    element: <NewDetailContainer />,
  },
  {
    key: "profile",
    name: "Profile",
    path: ROUTE_PATH.PROFILE_ME,
    element: <ProfileContainer />,
  },
  {
    key: "profile",
    name: "Profile Instrument Detail",
    path: ROUTE_PATH.PROFILE_ME_INSTRUMENT_DETAIL,
    element: <ProfileInstrumentDetailContainer />,
  },
  {
    key: "booking",
    name: "Booking",
    path: ROUTE_PATH.BOOKING,
    element: <BookingContainer />,
  },
  {
    key: "booking-detail",
    name: "BookingDetail",
    path: ROUTE_PATH.BOOKING_DETAIL,
    element: <BookingDetailContainer />,
  },
  {
    key: "reward-detail",
    name: "Reward Detail",
    path: ROUTE_PATH.REWARD_DETAIL,
    element: <RewardDetailContainer />,
  },

  {
    key: "music-practice-room-landing",
    name: "Music Practice Room Landing",
    path: ROUTE_PATH.MUSIC_HALL_AND_PRACTICE_DETAIL,
    element: <MusicHallAndPracticeDetailContainer />,
  },
  {
    key: "music-practice-room-landing",
    name: "Music Practice Room Landing",
    path: ROUTE_PATH.MUSIC_HALL_AND_PRACTICE_INFO_DETAIL,
    element: <MusicHallAndPracticeInfoContainer />,
  },
  
  {
    key: "schedule-reserve",
    name: "Schedule Reserve",
    path: ROUTE_PATH.MUSIC_PRACTICE_ROOM,
    element: <MusicPracticeRoomContainer />,
  },

  {
    key: "schedule-reserve",
    name: "Schedule Reserve",
    path: ROUTE_PATH.MUSIC_HALL_BOOKING_STEP_1,
    element: <Step1ScheduleReserveContainer rentalStep={1} />,
  },
  {
    key: "schedule-reserve",
    name: "Schedule Reserve",
    path: ROUTE_PATH.MUSIC_HALL_BOOKING_RENTAL_2,
    element: <Step1ScheduleReserveContainer rentalStep={2} />,
  },
  {
    key: "schedule-reserve",
    name: "Schedule Reserve",
    path: ROUTE_PATH.MUSIC_HALL_BOOKING_STEP_2,
    element: <Step2ScheduleReserveContainer />,
  },
  {
    key: "schedule-reserve",
    name: "Schedule Reserve",
    path: ROUTE_PATH.MUSIC_HALL_BOOKING_CONDITION_1,
    element: <StepConditionScheduleReserveContainer conditionStep={1} />,
  },
  {
    key: "schedule-reserve",
    name: "Schedule Reserve",
    path: ROUTE_PATH.MUSIC_HALL_BOOKING_CONDITION_2,
    element: <StepConditionScheduleReserveContainer conditionStep={2} />,
  },
  {
    key: "schedule-reserve",
    name: "Schedule Reserve",
    path: ROUTE_PATH.MUSIC_HALL_BOOKING_STEP_3,
    element: <Step3ScheduleReserveContainer />,
  },
  {
    key: "schedule-reserve",
    name: "Schedule Reserve",
    path: ROUTE_PATH.MUSIC_HALL_BOOKING_STEP_4,
    element: <Step4ScheduleReserveContainer />,
  },
  {
    key: "schedule-reserve",
    name: "Schedule Reserve",
    path: ROUTE_PATH.MUSIC_HALL_BOOKING_STEP_5,
    element: <Step5ScheduleReserveContainer />,
  },
  {
    key: "schedule-reserve",
    name: "Schedule Reserve",
    path: ROUTE_PATH.MUSIC_HALL_BOOKING_STEP_6,
    element: <Step6ScheduleReserveContainer />,
  },
  {
    key: "schedule-reserve",
    name: "Schedule Reserve",
    path: ROUTE_PATH.MUSIC_HALL_BOOKING_STEP_7,
    element: <Step7ScheduleReserveContainer />,
  },
  {
    key: "schedule-reserve",
    name: "Schedule Reserve",
    path: ROUTE_PATH.MUSIC_HALL_BOOKING_STEP_8,
    element: <Step8ScheduleReserveContainer />,
  },
  {
    key: "schedule-reserve",
    name: "Schedule Reserve",
    path: ROUTE_PATH.MUSIC_HALL_BOOKING_STEP_9,
    element: <Step9ScheduleReserveContainer />,
  },

  {
    key: "schedule-reserve",
    name: "Schedule Reserve",
    path: ROUTE_PATH.MUSIC_PRACTICE_ROOM_DETAIL,
    element: <MusicPracticeRoomDetailContainer />,
  },
  {
    key: "schedule-reserve",
    name: "Schedule Reserve",
    path: ROUTE_PATH.MUSIC_PRACTICE_ROOM_BOOKING_STEP_1,
    element: <MusicPracticeRoomStep1Container />,
  },
  {
    key: "schedule-reserve",
    name: "Schedule Reserve",
    path: ROUTE_PATH.MUSIC_PRACTICE_ROOM_BOOKING_STEP_CONTACT,
    element: <MusicPracticeRoomContactContainer />,
  },
  {
    key: "schedule-reserve",
    name: "Schedule Reserve",
    path: ROUTE_PATH.MUSIC_PRACTICE_ROOM_BOOKING_STEP_2,
    element: <MusicPracticeRoomStep2Container />,
  },
  {
    key: "schedule-reserve",
    name: "Schedule Reserve",
    path: ROUTE_PATH.MUSIC_HALL_AND_PRACTICE_THANK_YOU,
    element: <MusicHallAndPracticeThankContainer />,
  },
];

export default systemRoutes;
